import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const BRADEN_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.BRADEN_SCALE,
  title: 'Braden Scale for Pressure Sore Risk',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'percezione_sensoriale',
      'umidita',
      'attivita',
      'mobilita',
      'nutrizione',
      'frizione_scivolamento',
    ],
  },
  sections: [
    {
      name: 'braden',
      label: 'Braden Scale',
      fields: [
        // 1) PERCEZIONE SENSORIALE
        {
          key: 'percezione_sensoriale',
          label: 'Percezione sensoriale',
          type: 'number',
          min: 1,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '1': 'Completamente limitata: non risponde o non percepisce dolore/disagio.',
            '2': 'Molto limitata: risponde solo a stimoli dolorosi.',
            '3': 'Moderatamente limitata: risponde verbalmente ma presenta deficit parziali.',
            '4': 'Nessuna limitazione: percezione intatta.',
          },
          description:
            'Capacità del paziente di percepire e reagire a pressione/disagio.',
        },
        // 2) UMIDITÀ
        {
          key: 'umidita',
          label: 'Umidità della cute',
          type: 'number',
          min: 1,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '1': 'Costantemente umida.',
            '2': 'Molto umida.',
            '3': 'Occasionalmente umida.',
            '4': 'Raramente umida.',
          },
          description:
            'Valuta quanto spesso la cute è umida per sudore, urine o altri fattori.',
        },
        // 3) ATTIVITÀ
        {
          key: 'attivita',
          label: 'Livello di attività',
          type: 'number',
          min: 1,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '1': 'Allettato.',
            '2': 'Sedia/carrozzina.',
            '3': 'Dà alcuni passi.',
            '4': 'Cammina regolarmente.',
          },
          description: 'Misura il livello di attività fisica del paziente.',
        },
        // 4) MOBILITÀ
        {
          key: 'mobilita',
          label: 'Mobilità',
          type: 'number',
          min: 1,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '1': 'Completamente immobile.',
            '2': 'Molto limitata.',
            '3': 'Moderatamente limitata.',
            '4': 'Nessuna limitazione.',
          },
          description:
            'Valuta la capacità di cambiare e controllare la posizione del corpo.',
        },
        // 5) NUTRIZIONE
        {
          key: 'nutrizione',
          label: 'Stato nutrizionale',
          type: 'number',
          min: 1,
          max: 4,
          step: 1,
          maxScore: 4,
          valueDescriptions: {
            '1': 'Molto povera.',
            '2': 'Probabilmente inadeguata.',
            '3': 'Adeguata.',
            '4': 'Eccellente.',
          },
          description:
            'Valutazione del consumo abituale di cibo e apporto nutrizionale.',
        },
        // 6) FRIZIONE / SCIVOLAMENTO
        {
          key: 'frizione_scivolamento',
          label: 'Friction & Shear (Frizione / Scivolamento)',
          type: 'number',
          min: 1,
          max: 3,
          step: 1,
          maxScore: 3,
          valueDescriptions: {
            '1': 'Problema evidente.',
            '2': 'Problema potenziale.',
            '3': 'Nessun problema apparente.',
          },
          description:
            "Valutazione dell'attrito e scivolamento tra cute e superfici.",
        },
      ],
    },
  ],

  computedFields: [
    // TOTALE
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: 23,
    },

    // INTERPRETAZIONE AUTOMATICA
    {
      key: 'interpretazione',
      label: 'Interpretazione del rischio',
      type: 'text',
      calculation: `
        IF(totale <= 9, "Rischio molto alto",
          IF(totale <= 12, "Rischio alto",
            IF(totale <= 14, "Rischio moderato",
              "Rischio basso"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
